export const EXTRACTIVE_SEARCH_ENGINE = 'speciphic_nlp';
export const GENERATIVE_SEARCH_ENGINE = 'openai_configuration';
export const AZURE_OPENAI_SEARCH_ENGINE = 'azure_openai_configuration';
export const OPENAI_GPT_3_5_TURBO = 'Open AI GPT-3.5 Turbo';
